import React, { createContext, useState, useEffect } from "react";
import { jwtDecode } from "jwt-decode";

export const UserContext = createContext();

export const UserProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  const getUserFromToken = () => {
    try {
      const token = localStorage.getItem("token");
      if (!token) return null;

      const decoded = jwtDecode(token);
      const currentTime = Date.now() / 1000;
      if (decoded.exp < currentTime) return null;

      const isSuperAdmin = decoded.isSuperAdmin === true;
      const organisationRole = decoded.organisationRole || decoded.companyRole;
      const customerRole = decoded.customerRole;
      const legacyIsAdmin =
        decoded.isAdmin === true ||
        isSuperAdmin ||
        organisationRole === "organisation_admin" ||
        organisationRole === "company_admin" ||
        customerRole === "customer_admin";

      return {
        _id: decoded.userId,
        userId: decoded.userId,
        firstname: decoded.firstname,
        name: decoded.firstname,
        isAdmin: legacyIsAdmin,
        isSuperAdmin,
        globalRole: decoded.globalRole,
        companyRole: organisationRole,
        organisationRole,
        customerRole,
        activeCompanyId: decoded.activeCompanyId,
        activeOrganisationId: decoded.activeCompanyId,
        activeCustomerId: decoded.activeCustomerId,
        languages: decoded.languages || {},
      };
    } catch (error) {
      console.error("Error decoding token:", error);
      return null;
    }
  };

  useEffect(() => {
    const userData = getUserFromToken();
    setUser(userData);
    setIsLoading(false);

    const handleStorageChange = (e) => {
      if (e.key === "token") setUser(getUserFromToken());
    };
    const handleTokenUpdate = () => setUser(getUserFromToken());

    window.addEventListener("storage", handleStorageChange);
    window.addEventListener("tokenUpdated", handleTokenUpdate);

    return () => {
      window.removeEventListener("storage", handleStorageChange);
      window.removeEventListener("tokenUpdated", handleTokenUpdate);
    };
  }, []);

  return (
    <UserContext.Provider value={{ user, setUser, isLoading }}>
      {children}
    </UserContext.Provider>
  );
};
